<script setup lang="ts">
import ApplicationStepHeader from '@/components/common/application-step-header.vue';
import {storeToRefs} from 'pinia';
import {useApplicationStore} from '@/store/application';
import StfCard from '@/ui/card/StfCard.vue';
import OwnerTypeChoice from '@/components/contact-view/owner-type-choice.vue';
import useGoogleMaps from '@/composables/useGoogleMaps';
import {useOwnerStore} from '@/store/owner';
import OwnerForm from '@/components/contact-view/owner-form.vue';
import StfBulletPoint from '@/ui/list/StfBulletPoint.vue';
import useCountry from '@/composables/countryDependable';

const { hasValidation } = storeToRefs(useApplicationStore());
const { isOwnerStepValid, ownerType, country } = storeToRefs(useOwnerStore());
const appCountry = useCountry();

if (country.value === '') {
    country.value = appCountry.code;
}

useGoogleMaps();

</script>

<template>
    <StfCard :error="hasValidation && !isOwnerStepValid" :success="isOwnerStepValid">
        <template #title>
            <ApplicationStepHeader title="Trademark Owner" :help="true" help-title="Trademark Owner">
                <template #help>
                    <div class="mb-2">The Trademark Office requires the owner of a trademark to be a legal entity.</div>
                    <div class="mb-2"><b>Choose Individual:</b> if the owner of the trademark is a person or multiple people.</div>
                    <div class="mb-2"><b>Choose Company:</b> if the owner of the trademark is an incorporated company, club, charity or association.</div>
                    <div class="mb-2"><b>Tips:</b></div>
                    <div class="mb-2">
                        <StfBulletPoint padding-left="30px">
                            <li>Make sure you use your incorporated company name, not your business name.</li>
                            <li>If you don't have an incorporated entity, use your personal name instead.</li>
                            <li>For a trust, include the name of the trustee/s.</li>
                        </StfBulletPoint>
                    </div>
                </template>
            </ApplicationStepHeader>
        </template>
        <template #content>
            <owner-type-choice v-model="ownerType" />
            <owner-form v-if="ownerType"/>
        </template>
    </StfCard>
</template>

<style scoped>

</style>
